import { useContext } from "react";

import { MessageBoxContext } from "context/MessageBoxContext";

const useMessageBox = () => {
  const context = useContext(MessageBoxContext);

  if (context === undefined) {
    throw new Error("useMessageBox must be used within a MessageBoxProvider");
  }

  return context;
};

export { useMessageBox };
